import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {settingsActions, settingsSelectors} from '..';

export const useEmailSettings = () => {
   const settings = useSelector(settingsSelectors.emailSettings);
   const dispatch = useDispatch();
   React.useEffect(() => {
      dispatch(settingsActions.getEmailSettings());
   }, [dispatch]);

   return settings;
};
